export default [
  // 学员信息导入
  {
    name: 'student-import-popup',
    component: () => import(/* webpackChunkName: "studentImportPopup" */ './student-import.vue'),
  },
  // 学员信息导入
  {
    name: 'student-course-import-popup',
    component: () => import(/* webpackChunkName: "studentCourseImportPopup" */ './student-course-import.vue'),
  },
  // 线索导入
  {
    name: 'intentionClue-import-popup',
    component: () => import(/* webpackChunkName: "intentionClueImportPopup" */ './intentionClue-import.vue'),
  },
  // 班级导入
  {
    name: 'classInfo-import-popup',
    component: () => import(/* webpackChunkName: "classInfoImportPopup" */ './classInfo-import.vue'),
  },
  // 测评报告导入
  {
    name: 'ceping-import-popup',
    component: () => import(/* webpackChunkName: "cepingImportPopup" */ './ceping-import.vue'),
  },
  // 导入结果
  {
    name: 'import-result-success',
    component: () => import(/* webpackChunkName: "importResultSuccess" */ './import-result-success.vue'),
  },
];
